import useGet, { UseGetOptions } from '@/service-library/core-hooks/useGet'
import { getDetail } from '@/service-library/request-wrappers'

/**
 * MARK: Action Hook: Get Company Info for Org
 * Retrieves company info for a given organization.
 */
export function useGetQBOCompanyInfo({
  orgId,
  ...options
}: UseGetOptions<{ id: string; company_name: string }> & {
  orgId: string
}) {
  const query = useGet({
    queryKey: ['qbo_company_info', options.filters, orgId],
    serviceFn: ({ filters, ...serviceFnOptions }) => {
      return getDetail({
        url: '/v2/relay-qbo/imports/company_info',
        ...serviceFnOptions,
        filters: {
          ...filters,
          org_id: orgId,
        },
      })
    },
    ...options,
  })

  return {
    companyInfo: query.data,
    ...query,
  }
}
